var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.88867V2.55534M1.9987 8.55534H1.33203M3.66536 4.22201L3.2653 3.82194M12.332 4.22201L12.7322 3.82194M14.6654 8.55534H13.9987M6.66536 9.55534H9.33203M7.9987 9.55534V12.8887M10.332 11.8046C11.3414 11.0785 11.9987 9.89369 11.9987 8.55534C11.9987 6.3462 10.2078 4.55534 7.9987 4.55534C5.78956 4.55534 3.9987 6.3462 3.9987 8.55534C3.9987 9.89369 4.65599 11.0785 5.66536 11.8046V13.0887C5.66536 13.8354 5.66536 14.2088 5.81069 14.494C5.93852 14.7449 6.14249 14.9488 6.39338 15.0767C6.67859 15.222 7.05196 15.222 7.7987 15.222H8.1987C8.94543 15.222 9.3188 15.222 9.60402 15.0767C9.8549 14.9488 10.0589 14.7449 10.1867 14.494C10.332 14.2088 10.332 13.8354 10.332 13.0887V11.8046Z",
    stroke: "#12B76A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.6fd76d45476f47411fea5e5cf55373e0.svg";
export { ForwardRef as ReactComponent };